jQuery(document).ready(function () {

    var generateUrl = function(el) {
        var pid = el.attr('data-pid');
        var url = el.attr('data-url');

        return url.replace('dnGallerySwipe-image-id', pid);
    };


    $(document).on('click', '.dnJs-dnGallerySwipe-options-downloadOriginal', function (e) {
        e.preventDefault();

        url = generateUrl($(this));

        window.open(url);
    });

    $(document).on('click', '.dnJs-dnGallerySwipe-options-imageRequestDelete', function (e) {
        e.preventDefault();

        url = generateUrl($(this));

        window.location.href = url;
    });

    $(document).on('click', '.dnJs-dnGallerySwipe-options-setGalleryPreview', function (e) {
        e.preventDefault();
        el = $(this);
        url = generateUrl(el);

        $.ajax({
            url: url,
            type: "POST",
            success: function(){
                alert('Vorschaubild wurde gesetzt!');
            }
        });
    });

    $(document).on('click', '.dnJs-dnGallerySwipe-options-imageDelete', function (e) {
        e.preventDefault();
        el = $(this);
        url = generateUrl(el);

        if (confirm("Willst du das Bild wirklich löschen?")) {
            $.ajax({
                url: url,
                type: "POST",
                success: function(){
                    alert("Das Bild wurde gelöscht.");
                    window.location.href = window.location.href.split('#')[0];
                },
                error: function(){
                    alert("Es ist ein Fehler aufgetreten.");
                }
            });
        }
    });
});

function updatePidInSwiper(pid) {
    if (pid != 0) {
        $(".dnJs-dnGallerySwipe-options").each(function () {

            var el = $(this);

            el.attr('data-pid', pid);
        });
    }
};

